import { useContext } from 'react'

import { PrintShopFormContext } from '@lib/print/print-shop-form-context'
import { PrintShopFormStringsContext } from '@lib/print/print-shop-form-strings-context'

import Button from '@components/buttons/button'

interface ShopFormNextButtonProps {
  disabled?: boolean
}

const ShopFormNextButton = ({ disabled }: ShopFormNextButtonProps) => {
  const { setActiveStepIndex } = useContext(PrintShopFormContext)
  const { shopFormStrings } = useContext(PrintShopFormStringsContext)

  return (
    <Button
      variant="primary"
      color="red"
      size="normal-small"
      icon="ArrowRight"
      disabled={disabled}
      onClick={(event) => {
        event?.preventDefault()

        setActiveStepIndex((currentStepIndex) => currentStepIndex + 1)
      }}
    >
      {shopFormStrings.shopFormNextButton}
    </Button>
  )
}

export default ShopFormNextButton
